import { isCheckoutV2Eligible } from "../domain/featureFlags";
import { getSafePaymentAttempt } from "../domain/payload";
import { getCartInventoryUsage } from "../domain/cartInventory";
import { v4 as uuidv4 } from "uuid";
import { reconcileCart, RECONCILE_CHECKOUT_CART } from "../domain/reconcileCart";
import { getCheckoutLineId } from "../domain/cartContext";
import { saveLatestAbandonedCart } from "../../store/actions/abandonedCartSync";
import {
  CHECKOUT_V2_CLEAR_PAYMENT_ATTEMPT,
  CHECKOUT_V2_CLOSE_AUTH,
  CHECKOUT_V2_START_PAYMENT_ATTEMPT,
  CHECKOUT_V2_SET_CART_VALIDATION,
} from "./reducer";

export const checkoutV2LifecycleMiddleware = (store) => (next) => (action) => {
  const before = store.getState();
  if (["ADD_To_CART", "ADD_PROMO_ITEM"].includes(action.type) && action.payload &&
      isCheckoutV2Eligible(before.store?.store?.settings || {}, { address: before.customers?.address, cart: before.cart })) {
    action = { ...action, payload: { ...action.payload, lineId: uuidv4() } };
  }
  if (action.type === CHECKOUT_V2_SET_CART_VALIDATION && action.payload?.valid) {
    const rows = [...(before.cart?.cart || []), ...(before.cart?.promo_items || [])];
    const byId = new Map(rows.map((item, index) => [getCheckoutLineId(item, index), item]));
    action = { ...action, payload: { ...action.payload, removedLines: (action.payload.removedLines || []).map(line => {
      const item = byId.get(`${line.lineId}`) || {};
      return { ...line, name: item.name || line.name, arName: item.ar_name || line.arName };
    }) } };
  }
  const result = next(action);
  const state = store.getState();
  const settings = state.store?.store?.settings || {};
  if (
    !isCheckoutV2Eligible(settings, {
      address: state.customers?.address,
      cart: state.cart,
    })
  )
    return result;

  if (action.type !== RECONCILE_CHECKOUT_CART && state.cart && (
    action.type === CHECKOUT_V2_SET_CART_VALIDATION || action.type === "persist/REHYDRATE" ||
    before.store?.store !== state.store?.store
  )) {
    const reconciled = reconcileCart(state.cart, state.checkoutV2?.cartValidation, state.store?.store?.categories);
    if (reconciled !== state.cart) {
      if (action.type !== CHECKOUT_V2_SET_CART_VALIDATION) {
        store.dispatch({ type: CHECKOUT_V2_SET_CART_VALIDATION, payload: state.checkoutV2.cartValidation });
        return result;
      }
      store.dispatch({ type: RECONCILE_CHECKOUT_CART, payload: reconciled, storeSettings: settings });
      saveLatestAbandonedCart(store.dispatch, store.getState);
      return result;
    }
  }

  if (action.type !== "SET_USED_COMPONENTS" && (
    before.cart !== state.cart || before.store?.store !== state.store?.store ||
    ["persist/REHYDRATE", "REDUCE_QUANTITY", "FETCH_STORE", "FETCH_BRANCH"].includes(action.type)
  )) {
    const used = getCartInventoryUsage(state.cart, state.store?.store?.categories);
    if (JSON.stringify(used) !== JSON.stringify(state.store?.used_components || {}))
      store.dispatch({ type: "SET_USED_COMPONENTS", payload: used });
  }

  if (action.type === "SAVE_LAST_ORDER") {
    const attempt = getSafePaymentAttempt(action.payload);
    if (attempt) {
      store.dispatch({
        type: CHECKOUT_V2_START_PAYMENT_ATTEMPT,
        payload: attempt,
      });
    }
  } else if (action.type === "CLEAR_LAST_ORDER") {
    store.dispatch({ type: CHECKOUT_V2_CLEAR_PAYMENT_ATTEMPT });
  } else if (action.type === "SET_USER" && action.payload) {
    store.dispatch({ type: CHECKOUT_V2_CLOSE_AUTH });
  }

  return result;
};
